import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GlobalSettingsDetails } from "../services/website.services";
import { addData } from "../../../redux/slices/globalDetails";
import SwayydHeader from "./swayydHeader";
import SwayydFooter from "./swayydFooter";
import PageLoader from "./PageLoader";
import "../pages/swayyd.css";

const SwayydLayout = () => {
  const dispatch = useDispatch();
  const globalDetails = useSelector((state) => state.globalDetails?.data);

  useEffect(() => {
    // Ensure global settings are loaded for the layout and children
    if (!globalDetails) {
      GlobalSettingsDetails().then((res) => {
        if (res.data) {
          dispatch(addData(res.data));
        }
      });
    }
  }, [dispatch, globalDetails]);

  return (
    <div className="swayyd-body">
      <PageLoader />
      <SwayydHeader />
      <main style={{ minHeight: "calc(100vh - 72px - 300px)" }}>
        <Outlet />
      </main>
      <SwayydFooter />
    </div>
  );
};

export default SwayydLayout;
